
export function ApiConnectorBoxViewConstructor(services) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    isElementEditable: true,

    editElementModalController: [
      '$scope',
      '$mdDialog',
      'elementData',
      ($scope, $mdDialog, elementData) => {
        $scope.elementData = elementData;
        $scope.cancelDialog = $mdDialog.cancel;
        $scope.hideDialog = $mdDialog.hide;
      },
    ],
    editElementModalTemplate: `<angular-edit-api-connector
      [element-data]="elementData"
      (hide-dialog)="hideDialog($event)"
      (cancel-dialog)="cancelDialog()"
      ></angular-edit-api-connector>`,

    angularTemplate: '<angular-api-connector [element-data]="elementData"></angular-api-connector>',

    initialize: function () {
      this.model.set("canExportErrors", true);
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      this.updateValidity();
    },

    afterEditElement: function () {
      this.updateValidity();
    },

    updateValidity: function () {
      if (!this.angularScope.elementData) {
        this.model.setBoxValid(false);
      } else {
        const valid = !!this.angularScope.elementData.request.method;
        this.model.setBoxValid(valid);
      }
    },
  });
}
